import { styled } from 'styled-components';

import { theme } from '../../styles';
import { HelpIllustration } from '../../assets/illustrations';
import { extendChildrenWithProps } from '../../utils';
import { Container } from '../Layout';

const StyledContainer = styled(Container)`
  border-left: 1px solid ${theme.colors.lightGrey};
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 2.5rem;
  left: 0;
  transform: translate(-50%, 0);
`;

const Children = styled.div`
  border-bottom: 1px solid ${theme.colors.lightGrey};
`;

export const FAQSideContainer = ({ children }: any) => (
  <StyledContainer data-testid="test-faq-list" position="relative" flexGrow={1} paddingTop={80} paddingBottom={80}>
    <IconWrapper>
      <HelpIllustration width={25} title="Vanliga Frågor" />
    </IconWrapper>
    <Children>{extendChildrenWithProps(children, { eService: true })}</Children>
  </StyledContainer>
);
